import script from "./SentimentSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SentimentSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SentimentSwitcher.vue?vue&type=style&index=0&id=dc8a84ba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc8a84ba"]])

export default __exports__